import { render, staticRenderFns } from "./ReSelectClearable.vue?vue&type=template&id=dff8bdf6&scoped=true"
import script from "./ReSelectClearable.vue?vue&type=script&lang=js"
export * from "./ReSelectClearable.vue?vue&type=script&lang=js"
import style0 from "./ReSelectClearable.vue?vue&type=style&index=0&id=dff8bdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8bdf6",
  null
  
)

export default component.exports